import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PowerUpsPage } from './power-ups.page';

const routes: Routes = [
  {
    path: '',
    component: PowerUpsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PowerUpsPageRoutingModule {}
